import { Helpers } from '../../helpers';
import { IDurationFactorType } from '../../interfaces/iduration-factor-type';
import { AreaFactor } from '../area-factor';

export class DurationFactorTypeBase {
  DurationFactorTypeId: number;
  Name: string;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  AreaFactors_DurationFactorType?: Array<AreaFactor> | null;

  constructor(item?: IDurationFactorType) {
    if (item) {

      this.DurationFactorTypeId = item.DurationFactorTypeId;
      this.Name = item.Name;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.AreaFactors_DurationFactorType = Helpers.createClassArray(AreaFactor, item.AreaFactors_DurationFactorType);
    }
  }
}